import { Component, Inject, Output, EventEmitter, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthServices, AlertServices, UserServices, AppServices } from '@services';
import { GuestModel, UserModel } from '@models';

import { environment as env } from 'environments/environment';
import { ClockService } from "@services";
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-lock',
    templateUrl: './lock.component.html',
    styleUrls: ['./lock.component.scss']
})

export class LockComponent {
    @Output() onUnLockRequest = new EventEmitter(); //Added for Modal
    @Output() onLogOutRequest = new EventEmitter(); //Added for Modal

    private _clockSubscription: Subscription;
    time: Date;
    RemainingTimer: number = env.loginTimeout - env.lockTimeout;
    DisplayRemainingTime: string = ''

    LockForm: FormGroup;
    LoggedInUser: UserModel;
    Guest: GuestModel = new GuestModel({});

    isLoading = false;
    HiddenPassword = true;

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        @Inject('AppServices') private _appServices: AppServices,
        @Inject('UserServices') private _userServices: UserServices,
        @Inject('ClockService') private clockService: ClockService,
        @Inject('AlertServices') private _alertServices: AlertServices,
        //public translate: TranslateService, // No need if not used in TS
        private formBuilder: FormBuilder
    ) { }
    //On Every Click on the Lock Screen Refresh Session Timeout
    //If we do not need to Reset App timer then disable this
    @HostListener('click') onClick() { this.CheckRemainingTime() }

    EnterKeyTrigger(_event: KeyboardEvent) {
        if (_event.keyCode === 13) {
            this.ProcessUnLock();
            _event.stopPropagation();
            _event.preventDefault();
        }
    }

    ngOnInit() {

        this.isLoading = false;

        this.CheckRemainingTime();

        this._clockSubscription = this.clockService.getClock().subscribe((time) => {
            this.time = time //Real Timer Not used in this section
            this.RemainingTimer = this.RemainingTimer - 1000 //in milliseconds
            this.DisplayRemainingTime = this.clockService.Convert_milliseconds_To_Hours(this.RemainingTimer)
        });

        this.LockForm = this.formBuilder.group({
            password: ['', [Validators.required]],
        });

        this.LoggedInUser = this._userServices.getLoggedInUser();
    }

    CheckRemainingTime() {

        //IF WE WANT TO RESET APP AND LOCK TIMER
        this._appServices.RefreshSession();
        const _date = localStorage.getItem('_date');

        if (_date) {
            const _lastTime = Number(_date);
            const _now = new Date().getTime();
            const _idleTime = Math.abs(_now - _lastTime);
            this.RemainingTimer = env.loginTimeout - env.lockTimeout
            this.DisplayRemainingTime = this.clockService.Convert_milliseconds_To_Hours(this.RemainingTimer)
        }
    }


    ProcessUnLock() {

        if (this.LockForm.valid) {

            this.isLoading = true;

            this.Guest.Username = this.LoggedInUser.Username
            this.Guest.Password = this.LockForm.value['password']

            this._authServices.UnLock(this.Guest).subscribe(
                () => {
                    this.isLoading = false;
                    this._clockSubscription.unsubscribe();
                    this.onUnLockRequest.emit();//Added for Modal

                }, (_error) => {
                    this.isLoading = false;
                    const _ErrorResponse = JSON.parse(_error._body)
                    this._alertServices.ShowMessage('error', 'app.trn-error-title', _ErrorResponse.ErrorMessage);
                });

        }

    }

    goToLogin() {
        this.onLogOutRequest.emit() //Added for Modal
        this._appServices.Logout()
    }

}
